import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import {
  getCodeData,
  getInitFormData,
  getAutoSlip,
  getSearchData,
} from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SN_MTL_ADJ_REG_001_POP_001 from "@menu/MTL/SN_MTL_ADJ_REG_001/SN_MTL_ADJ_REG_001_POP_001";
import SN_MTL_ADJ_REG_001_POP_002 from "@menu/MTL/SN_MTL_ADJ_REG_001/SN_MTL_ADJ_REG_001_POP_002";
import { showPopupModal } from "@widgets/CommonModal";
import SnButton from "@shared/components/SnButton";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_MTL_ADJ_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global(); // Login user 정보
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns1, setColums1] = useState<any[]>([]); // gridApiRefH 컬럼 설정 관련
  const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRefH datasource 관련

  const [btnText, setBtnText] = useState<string>("조정확정");
  const [noAdj, setAdj] = useState<String>("");
  const [noReview, setReview] = useState<String>("");
  const [cdGp, setGp] = useState<String>("");
  const [adjBtn, setAdjbtn] = useState<String>("P");
  const [editEnabled, seteditEnabled] = useState<Boolean>(true);
  //#endregion

  //#region grid 높이 관련
  let height1 = "49.5%";

  const menuSize = localStorage.getItem("menuSize");
  if (menuSize) {
    const menu = JSON.parse(menuSize);
    height1 = menu.SN_MTL_ADJ_REG_001?.grid1Height
      ? menu.SN_MTL_ADJ_REG_001?.grid1Height
      : height1;
  }
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      try {
        const defaultForm = {
          cd_biz: userInfo.cd_biz,
          cd_emp: userInfo.cd_emp,
          nm_emp: userInfo.nm_emp,
          dt_adjust: todayform,
        };
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);

        setFormData({ ...rtn.formData, ...defaultForm });

        setColums1(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    try {
      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        cd_biz: selectedFormData.cd_biz,
      };
      const component = (
        <SN_MTL_ADJ_REG_001_POP_001 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "조정조회",
        children: component,
      });
      if (!result || result === "close") return;
      const headerResult = result[0];

      const newData = {
        cd_firm: userInfo.cd_firm,
        cd_biz: headerResult[0].cd_biz,
        cd_wh: headerResult[0].cd_wh,
        dt_adjust: headerResult[0].dt_adjust,
        no_adjust: headerResult[0].no_adjust,
      };

      const params = {
        id: "sn_mtl_adj_reg_001_01",
        params: { ...newData },
      };

      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);

      setAdj(headerResult[0].no_adjust);

      const newFormdata = {
        cd_biz: headerResult[0].cd_biz,
        cd_wh: headerResult[0].cd_wh,
        nm_wh: headerResult[0].nm_wh,
        cd_emp: headerResult[0].cd_emp,
        nm_emp: headerResult[0].nm_emp,
        no_adjust: headerResult[0].no_adjust,
        st_adjust: " ",
      };
      if (headerResult[0].st_adjust === "P") {
        changeAdjbtn("P");
        newFormdata.st_adjust = "P";
      } else {
        changeAdjbtn("F");
        newFormdata.st_adjust = "F";
      }

      setFormData({ ...formData, ...newFormdata });
      //need control enable/disable
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));

        gridApiRefH.current.selectAndFocusRow(0);
      }
      gridApiRefH.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onInsert = async () => {
    try {
      const dt = gridApiRefH.current.getChange();
      if (dt !== null) {
        const conFirm = await showDialog(
          "confirm",
          "저장되지 않은 내역은 초기화됩니다. 진행하시겠습니까?"
        );
        if (!conFirm) {
          return;
        }
      }

      gridApiRefH.current?.deleteAllRows();
      gridApiRefH.current.resetUpdate();

      const formNewdata = {
        cd_biz: userInfo.cd_biz,
        dt_adjust: todayform,
        cd_wh: "",
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        no_adjust: "",
        st_adjust: "",
      };
      //need control disable/enable
      setFormData({ ...formData, ...formNewdata });
      setAdj("");
    } catch (error: any) {}
  };

  const onDelete = async () => {
    const selectedReview = gridApiRefH.current.getSelectedRows();
    const firstRow: any = Array.from(selectedReview)[0];

    if (!editEnabled) {
      showDialog("alter", "이미 진행된 건입니다.");
      return;
    }

    if (noAdj === "") {
      gridApiRefH.current?.deleteAllRows();
      gridApiRefH.current.resetUpdate();
    } else {
      const confirm = await showDialog("confirm", "삭제 하시겠습니까?");
      if (!confirm) {
        return;
      }
      const params = {
        cd_firm: userInfo.cd_firm,
        no_adjust: noAdj,
        no_review: firstRow?.no_review,
      };
      if (firstRow?.no_review) {
        const result: any = await callApi(
          "SN_MTL_ADJ_REG_001_OnDelete",
          params
        );
        if (result) {
          gridApiRefH.current?.deleteAllRows();
          gridApiRefH.current.resetUpdate();
        }
      }
    }
    const formNewdata = {
      cd_biz: userInfo.cd_biz,
      dt_adjust: todayform,
      cd_wh: "",
      cd_emp: userInfo.cd_emp,
      nm_emp: userInfo.nm_emp,
      no_adjust: "",
      st_adjust: "",
    };
    //need control disable/enable
    setFormData({ ...formData, ...formNewdata });
    setAdj("");
  };

  const onAddRow = async () => {
    try {
      if (!editEnabled) {
        showDialog("alter", "이미 진행된 건입니다.");
        return;
      }
      if (!controlNullCheck()) return;

      const newRow = {};
      gridApiRefH.current?.addRow(newRow);
      //need control enable/disable logic
    } catch (error: any) {}
  };

  const onDeleteRow = async () => {
    if (!editEnabled) {
      showDialog("alter", "이미 진행된 건입니다.");
      return;
    }
    gridApiRefH.current?.deleteSelectedRows();
    //need control enable/disable logic
  };

  //initialize new row(set default value)
  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const rowCount = gridApiRefH.current.api.getDisplayedRowCount();
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_spare: "*",
        no_line: rowCount + 1,
      };

      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };

  const onSave = async () => {
    let no_slip: any;
    let no_adj: any;
    const dt = [];
    let mtlAdjustlChanges;

    const searchFormData = searchRef.current.getFormdata();
    const params = await getCodeData(
      "",
      `select cd_dept from mas_emp 
     where cd_firm = '${userInfo.cd_firm}' 
     and cd_emp = '${searchFormData.cd_emp}'`,
      false
    );

    const paramCdio = await getCodeData(
      "",
      `select cd_io from mas_iotype 
     where cd_firm = '${userInfo.cd_firm}' 
     and cd_io = '920'`,
      false
    );
    try {
      gridApiRefH.current.api.stopEditing();
      const requiredValuesCheckH = gridApiRefH.current.requiredValuesCheck();

      if (!requiredValuesCheckH) {
        return;
      }

      mtlAdjustlChanges = gridApiRefH.current.getChange();
      const lineInserts = mtlAdjustlChanges.insert ?? [];

      if (mtlAdjustlChanges.modifiedRowcount === 0) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      if (!noAdj) {
        const cd_module: any = Menuprops.cd_module;
        const cd_menu: any = Menuprops.cd_menu;
        no_slip = await getAutoSlip(
          cd_module,
          14,
          searchFormData.dt_adjust,
          cd_menu
        );
        no_adj = no_slip;
      }

      for (let row of lineInserts) {
        if (!row.no_adjust) {
          if (noAdj) {
            row.no_adjust = noAdj;
          } else {
            row.no_adjust = no_slip;
          }
        }
      }

      if (!noAdj) {
        const newData = {
          cd_firm: userInfo.cd_firm,
          cd_biz: searchFormData.cd_biz,
          cd_wh: searchFormData.cd_wh,
          dt_adjust: searchFormData.dt_adjust,
          ym_adjust: searchFormData.dt_adjust.substring(0, 6),
          cd_dept: params[0]["cd_dept"],
          cd_emp: searchFormData.cd_emp,
          cd_io: paramCdio[0]["cd_io"],
          no_review: noReview,
          st_adjust: "P",
          no_adjust: no_adj,
        };
        dt.push(newData);
      }

      const SaveData = {
        mtl_adjusth: { insert: dt },
        mtl_adjustl: mtlAdjustlChanges,
      };

      await fnSave("SN_MTL_ADJ_REG_001_SAVE_01", SaveData);

      const paramData = {
        no_adjust: no_adj,
        cd_firm: userInfo.cd_firm,
        no_review: noReview,
      };
      if (dt !== null && noReview) {
        const result: any = await callApi(
          "SN_MTL_ADJ_REG_001_OnSave",
          paramData
        );
        const newFD = {
          no_adjust: no_adj,
        };
        setFormData({ ...formData, ...newFD });
      }

      gridApiRefH.current.resetUpdate();
    } catch (error: any) {
      gridApiRefH.current.resetUpdate();
    }
  };
  //#endregion

  //#region  Event Method
  const onGrid2BtnsClick = async (id: string) => {
    if (id === "addRow") {
      onAddRow();
    }

    if (id === "deleteRow") {
      onDeleteRow();
    }
  };
  const onGrid1BtnsClick = async (id: string) => {
    let dt = gridApiRefH.current.getChange();
    const rowCount = gridApiRefH.current.api.getDisplayedRowCount();
    if (id === "btnApply") {
      try {
        if (dt !== null || rowCount > 1) {
          const conFirm = await showDialog(
            "confirm",
            "저장되지 않은 내역은 초기화됩니다. 진행하시겠습니까?"
          );
          if (!conFirm) {
            return;
          }
        }
        const selectedFormData = searchRef.current.getFormdata();
        const selectedData = {
          cd_biz: selectedFormData.cd_biz,
        };
        const component = (
          <SN_MTL_ADJ_REG_001_POP_002 selectedData={selectedData} />
        );
        const result = await showPopupModal({
          title: "실사적용",
          children: component,
        });
        if (!result || result === "close") return;
        const headerResult = result[0];

        const newData = {
          cd_firm: userInfo.cd_firm,
          cd_biz: headerResult[0].cd_biz,
          cd_wh: headerResult[0].cd_wh,
          no_review: headerResult[0].no_review,
          dt_review: headerResult[0].dt_review,
        };

        const params = {
          id: "sn_mtl_adj_reg_001_btnReturnSearch",
          params: { ...newData },
        };

        setDataSource1([]);
        const data: any = await fnGetDataSet(params);
        setDataSource1(data[0]);
        setGp(headerResult[0].cd_gp);
        setReview(headerResult[0].no_review);

        const formNewdata = {
          cd_biz: headerResult[0].cd_biz,
          cd_wh: headerResult[0].cd_wh,
          nm_wh: headerResult[0].nm_wh,
          cd_emp: headerResult[0].cd_emp,
          nm_emp: headerResult[0].nm_emp,
          no_adjust: "",
          st_adjust: "P",
        };
        //need control disable/enable
        setFormData({ ...formData, ...formNewdata });

        if (data[0] && data[0].length > 0) {
          await new Promise((resolve) => setTimeout(resolve, 50));

          gridApiRefH.current.selectAndFocusRow(0);
        }
        gridApiRefH.current.resetUpdate();
      } catch (error: any) {
        showDialog("error", error.message);
      }
    }

    if (id === "btnAdjset") {
      let no_adj;
      const searchFormData = searchRef.current.getFormdata();
      const mtlQtioh = [];
      const mtlQtio = [];

      const selectedReview = gridApiRefH.current.getSelectedRows();
      const firstRow: any = Array.from(selectedReview)[0];

      if (rowCount < 1) {
        return;
      }
      dt = gridApiRefH.current.getChange();
      if (dt !== null) {
        const conFirm = await showDialog(
          "confirm",
          "저장되지 않은 내역은 초기화됩니다. 진행하시겠습니까?"
        );
        if (!conFirm) {
          return;
        }
      }
      no_adj = firstRow?.no_adjust;

      switch (adjBtn) {
        case "P":
          try {
            const PcdIo = await getCodeData(
              "",
              `select cd_io, fg_slip, tp_slip, fg_io, fg_money from mas_iotype 
     where cd_firm = '${userInfo.cd_firm}' 
     and cd_io = '920'`,
              false
            );

            const Pdept = await getCodeData(
              "",
              `select cd_dept from mas_emp 
     where cd_firm = '${userInfo.cd_firm}' 
     and cd_emp = '${searchFormData.cd_emp}'`,
              false
            );

            const qtioH = {
              cd_firm: userInfo.cd_firm,
              no_io: no_adj,
              cd_biz: searchFormData.cd_biz,
              cd_wh: searchFormData.cd_wh,
              dt_io: searchFormData.dt_adjust,
              cd_exch: "000",
              rt_exch: 1,
              cd_io: PcdIo[0]["cd_io"],
              fg_slip: PcdIo[0]["fg_slip"],
              tp_slip: PcdIo[0]["tp_slip"],
              fg_io: PcdIo[0]["fg_io"],
              fg_money: PcdIo[0]["fg_money"],
              cd_dept: Pdept[0]["cd_dept"],
              cd_emp: searchFormData.cd_emp,
              cd_gp: cdGp,
              yn_autoprocess: "N",
              am: 0,
              am_k: 0,
              am_vat: 0,
              am_supply: 0,
              fg_map: "1",
              no_hst: 0,
            };
            mtlQtioh.push(qtioH);

            const getRenderedNodes = gridApiRefH.current.api.getRenderedNodes();

            for (const node of getRenderedNodes) {
              if (!node?.data) continue;
              const Qtio = {
                cd_firm: qtioH.cd_firm,
                no_io: qtioH.no_io,
                no_line: node.data?.no_line,
                cd_biz: qtioH.cd_biz,
                cd_wh: qtioH.cd_wh,
                cd_io: qtioH.cd_io,
                fg_slip: qtioH.fg_slip,
                tp_slip: qtioH.tp_slip,
                fg_io: qtioH.fg_io,
                fg_money: qtioH.fg_money,
                cd_item: node.data?.cd_item,
                qt_good: node.data?.qt_adjust_good + node.data?.qt_adjust_rcl,
                qt_bad: node.data?.qt_adjust_bad,
                qt: node.data?.qt_adjust,
                no_req: qtioH.no_io,
                dt_io: qtioH.dt_io,
                um: 0,
                am: 0,
                rt_exch: 1,
                um_k: 0,
                am_k: 0,
                am_vat: 0,
                um_supply: 0,
                am_supply: 0,
                no_line_req: 0,
                no_line_order: 0,
              };
              mtlQtio.push(Qtio);
            }
            const saveData = {
              mtl_qtioh: { insert: mtlQtioh },
              mtl_qtio: { insert: mtlQtio },
            };
            const returnMsg = await fnSave(
              "SN_MTL_ADJ_REG_001_SAVE_02",
              saveData
            );

            const params = {
              cd_firm: userInfo.cd_firm,
              no_adjust: no_adj,
            };
            const result: any = await callApi("UPDATE_STADJ_TO_F", params);
            changeAdjbtn("F");
          } catch (error: any) {}
          break;

        case "F":
          try {
            const params = {
              cd_firm: userInfo.cd_firm,
              no_adjust: no_adj,
            };
            const result: any = await callApi(
              "DUO_MTL_DELETE_UPDATE_STADJ",
              params
            );
          } catch (error: any) {}
          changeAdjbtn("P");
          break;
      }
    }
  };

  const onCellValueChangedH = async (event: any) => {
    if (!event) return;
  };

  const controlNullCheck = (): boolean => {
    const searchCtr = searchRef.current.getFormdata();
    if (searchCtr.cd_biz === "") {
      showDialog("alter", "사업장이 입력되지 않았습니다.");
      return false;
    } else if (searchCtr.dt_adjust === "") {
      showDialog("alter", "실사일이 입력되지 않았습니다.");
      return false;
    } else if (searchCtr.cd_wh === "") {
      showDialog("alter", "창고가 입력되지 않았습니다.");
      return false;
    }
    if (searchCtr.cd_emp === "") {
      showDialog("alter", "담당자가 입력되지 않았습니다.");
      return false;
    }

    return true;
  };

  const changeAdjbtn = (st: String) => {
    if (st == "P") {
      setBtnText("조정확정");
      setAdjbtn("P");
      seteditEnabled(true);
    } else {
      setBtnText("조정취소");
      setAdjbtn("F");
      seteditEnabled(false);
    }
  };
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div style={{ height: "calc(80%)" }}>
        <SnGrid
          // Pros로 받은 Menuprops
          seq={1} // Grid Seqno 우클릭 메뉴용
          ref={gridApiRefH} // Grid Name
          columnConfig={columns1} // 컬럼 설정 전달
          rowData={dataSource1} // Datasource
          isEditable={true} // 수정 가능여부
          rowSelection="single" // 로우 선택 모드 (단일)
          onBeforeAddRow={onBeforeAddRowH} // 행추가 전 유효성 체크 및 초기값 설정
          onCellValueChanged={onCellValueChangedH}
          onBtnAddClick={onGrid2BtnsClick}
          onBtnDeleteClick={onGrid2BtnsClick}
          title="    " // 그리드 타이틀 정보
          header={
            <div>
              <SnButton
                text={"실사적용"}
                onClick={() => {
                  onGrid1BtnsClick("btnApply");
                }}
              />
              <SnButton
                text={btnText}
                onClick={() => {
                  onGrid1BtnsClick("btnAdjset");
                }}
              />
            </div>
          }
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_MTL_ADJ_REG_001;
